// React imports.
import React from "react";

import { Assessment3StepsEnum } from "../state";
import { Assessment3HHDataReceivedStatusEnum } from "../state";


const Assessment3DataCollectedTopParagraph = ({fuelType }) => (
    <div>
        {(fuelType.numHouseholds === 0)
          &&<span>
                You have indicated that your state/territory does not serve households with&nbsp;
                {fuelType.descriptionHeat}. Therefore it would not be applicable for you to conduct
                a check of&nbsp;{fuelType.description}&nbsp;expenditure data.
            </span>
          }


        {fuelType.dataReceivedStatus == Assessment3HHDataReceivedStatusEnum.OverTargetNoIssues
          &&<span>
              Your data recording and processing efforts for&nbsp;{fuelType.descriptionHeat}&nbsp;households have
              not been flagged because the number of households for whom you received data
              from your vendors is greater than or equal to&nbsp;{fuelType.targetPercentHouseholdsCoveredString}&nbsp;of your total assisted households.
            </span>
          }
          {fuelType.dataReceivedStatus == Assessment3HHDataReceivedStatusEnum.NotMeetTarget
            &&<span>
              <p>
                  Your data recording and processing efforts for&nbsp;{fuelType.descriptionHeat}&nbsp; 
                  households have been flagged because the data you collected only covers
                  &nbsp;{fuelType.percentHouseholdsDataReceived}&nbsp; of your total assisted households. 
              </p>
              <p>
                  This indicates that your vendors may not be providing you with enough
                  billing data to ensure that your sample is representative of all LIHEAP
                  households in your state/territory. 
              </p>
            </span>
          }
    </div>
);

export default Assessment3DataCollectedTopParagraph;
